import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	communication: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-communications.communications.non-final',
		defaultMessage: 'Communications',
		description: 'Communication dropdown item to manage stake holder communications',
	},
	overview: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-communications.overview.non-final',
		defaultMessage: 'Overview',
		description: 'stake holder communications overview page.',
	},
	statusPages: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-communications.status-pages.non-final',
		defaultMessage: 'Status Pages',
		description: 'stake holder communications status pages page.',
	},
	communicationPlans: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-communications.communication-plans.non-final',
		defaultMessage: 'Communication Plans',
		description: 'stake holder communications communication plans page.',
	},
	stakeholders: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-communications.stakeholders.non-final',
		defaultMessage: 'Stakeholders',
		description: 'stake holder communications stakeholders page.',
	},
	channels: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-communications.channels.non-final',
		defaultMessage: 'Channels',
		description: 'stake holder communications channels page.',
	},
	reports: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-communications.reports.non-final',
		defaultMessage: 'Reports',
		description: 'stake holder communications reports page.',
	},
});
